import React from 'react'

const Innovation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="59"
      viewBox="0 0 59 59"
    >
      <g>
        <g>
          <path
            fill="#c760f6"
            d="M0 5a5 5 0 0 1 5-5h49a5 5 0 0 1 5 5v49a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"
          />
        </g>
        <g>
          <g>
            <path
              fill="#fff"
              d="M38.652 40.913a14.615 14.615 0 0 0 5.438-10.558h6.875v-1.72H44.09a14.614 14.614 0 0 0-5.438-10.558 28.29 28.29 0 0 1 14.713 11.418 28.29 28.29 0 0 1-14.713 11.418zm-9.889-3.665v5.118c-6.39-.437-11.477-5.563-11.911-12h5.08v-1.721h-5.08c.434-6.438 5.521-11.564 11.911-12.001v5.118h1.708v-5.118c6.39.437 11.477 5.563 11.911 12h-5.08v1.721h5.08c-.434 6.438-5.521 11.564-11.911 12.001v-5.118zM5.87 29.495a28.29 28.29 0 0 1 14.713-11.418 14.615 14.615 0 0 0-5.438 10.558H8.27v1.72h6.875a14.615 14.615 0 0 0 5.438 10.558A28.29 28.29 0 0 1 5.869 29.495zm49.234-.453c-5.337-8.575-14.587-13.883-24.632-14.134V8h-1.708v6.908c-10.045.251-19.295 5.56-24.632 14.134a.865.865 0 0 0 0 .916c5.337 8.575 14.587 13.883 24.632 14.134V51h1.708v-6.908c10.045-.251 19.295-5.56 24.632-14.134a.865.865 0 0 0 0-.916z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M30.534 33.619a4.575 4.575 0 1 1 0-9.15 4.575 4.575 0 0 1 0 9.15zm0-10.979a6.404 6.404 0 0 0-6.404 6.404 6.412 6.412 0 0 0 6.404 6.405 6.404 6.404 0 1 0 0-12.809z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M10.303 8a.813.813 0 0 0-.813.813v6.506h1.626V9.626h5.693V8z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M48.936 8H42.43v1.626h5.693v5.693h1.626V8.813A.813.813 0 0 0 48.936 8z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M48.123 43.68v5.693H42.43v1.626h6.506c.449 0 .813-.364.813-.813V43.68z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M11.116 49.373V43.68H9.49v6.506c0 .449.364.813.813.813h6.506v-1.626z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Innovation
